import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson7 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
         $x = 5;
         $y = 3;

         //Arithmetic operators
         echo $x + $y; //8
         echo $x - $y; //2
         echo $x / $y; //1.6666666666667
         echo $x % $y; //2
         echo $x ** $y; //125

         //Assignment Operators
         $x += $y  //$x is now 8
         $x -= $y  //$x is now 5
         $x *= $y  //$x is now 15
         $x /= $y  //$x is now 5
         $x %= $y  //$x is now 2
         ?>

        `
      );
      const code1 = (
        'text',
        `
        <?php
          $x =5;
          $y = 3;

          //Comparison operators
          if($x = $y) {
            echo 'x is equal to y';
          }else{
            echo 'x is not equal to y';
          }

          if($x < $y){
            echo 'x is less than y';
          }else{
            echo 'x is not less than y';
          }

          //inncrement/ Decrement operators
          echo ++$x; //6
          echo ==$y; //2
          ?>

        `
      );
      const code2 = (
        'text',
        `
        <?php
          $x = 5;
          $y = 3;

          //Logical operators
          if($x >0 and $y > 0){
            echo 'x and y are both greater than 0';
          }

          if($x >0 or $y > 0){
            echo 'x or y is greater than 0';
          }

          if($x >0 xor $y > o){
            echo 'x or y is greater than 0 but not both';
          }

          //String operators
          $string1 = 'Hello';
          $string2 = 'world';
          echo £string1 . ' '.$string2; // Hello world
         ?>

        `
      );




  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">

    <h3><strong>PHP Operators</strong></h3>
      <p>PHP Operators are symbols or keywords used to perform operations on variables, values, or expressions.</p>
     <p>PHP supports a variety of operators that can be used in your code. Operators are symbols that perform specific operations on one or more operands (values or variables).</p>
     <ol class="list-group list-group-numbered mb-2">
      <li class="list-group-item"><b>Arithmetic operators:</b> +, -, *, /, % (modulus), ** (exponentiation)</li>
      <li class="list-group-item"><b>Assignment operators:</b> =, +=, -=, *=, /=, %=, .= (concatenation assignment)</li>
      <li class="list-group-item"><b>Comparison operators:</b> ==, !=, &lt;, &gt;, &lt;=, &gt;= </li>
      <li class="list-group-item"><b>Increment/decrement operators:</b> ++, --</li>
      <li class="list-group-item"><b>Logical operators:</b> and, or, xor, &&, ||, ! (not)</li>
      <li class="list-group-item"><b>String operators:</b> . (concatenation)</li>
      <li class="list-group-item"><b>Array operators:</b> +, ==, !=, ===, !==</li>
      </ol>

      <CopyBlock
                        language={"php"}
                        text={code}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      /> <br/>

<CopyBlock
                        language={"php"}
                        text={code1}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      /> <br/>

<CopyBlock
                        language={"php"}
                        text={code2}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />  <br/>



    </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson7
